import { useTranslation } from 'react-i18next';
import Theme from '@dagensmat/carrot/Theme';
import { PRODUCER_SHOP_CLICK_PRODUCT_SIGNUP_CTA, track } from 'utils/mixpanel';
import { ButtonLink } from '_common/components/button/Button.style';
import useRedirectLogin from '_common/hooks/useRedirectLogin';

const SignUpToTradeButton = () => {
  const { t } = useTranslation();

  const { get: getRedirectLogin } = useRedirectLogin();

  return (
    <ButtonLink
      my={Theme.Spacings.xs}
      variant="primary"
      to={`/letsgo?redirectLogin=${getRedirectLogin()}`}
      onClick={event => {
        event.stopPropagation();
        track(PRODUCER_SHOP_CLICK_PRODUCT_SIGNUP_CTA);
      }}
    >
      {t('common:SignUpToTradeButton')}
    </ButtonLink>
  );
};

export default SignUpToTradeButton;
